import React from "react"

import chromeDebug from "assets/cloudroom-chrome.png"
import safariDebug from "assets/cloudroom-safari.png"
import { detect } from "detect-browser"

export type ErrorModalProps = {
  error: any
  mayContinue: boolean
  userType: "Teacher" | "Tutor" | "Student"
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  error,
  mayContinue = false,
  userType,
}) => {
  const browser = detect()

  return (
    <div className="px-2">
      {error?.name === "DevicePermissions" ? (
        <>
          {mayContinue ? (
            <div className="mb-4 italic">
              If you have been specifically instructed to join without a camera,
              you may click the red "Continue Without Camera" button below.
            </div>
          ) : null}
          <div>
            {error.message}. Please follow these steps to unblock your devices:
            {browser?.name === "ios" ? (
              <img src={safariDebug} alt="Cloud Room Debug" />
            ) : (
              <img src={chromeDebug} alt="Cloud Room Debug" />
            )}
            <ol className="pl-5 [&>li]:list-decimal">
              {browser?.name === "ios" ? (
                <>
                  <li>
                    Right Click (or hold control and click): URL Bar as shown in
                    the picture
                  </li>
                  <li>Click: Settings for This Website...</li>
                  <li>Find Camera and Microphone options near bottom</li>
                  <li>Change option to Allow</li>
                </>
              ) : (
                <>
                  <li>Click the Settings Icon circled in the picture</li>
                  <li>Toggle Camera, Microphone and Sound to on</li>
                  <li>Click away from settings box</li>
                  <li>Click the "Reload" button that appears</li>
                </>
              )}
            </ol>
            {userType === "Tutor" ? (
              <div>
                If you have already completed the steps above, please reach out
                to your admin support channel in slack.
              </div>
            ) : userType === "Student" || userType === "Teacher" ? (
              <div>
                If the above does not work, click contact below and a member of
                our support team will reach out to help you resolve the issue.
              </div>
            ) : null}
          </div>
        </>
      ) : error?.name === "MissingDevice" ? (
        <div>
          {mayContinue ? (
            <div className="mb-4 italic">
              If you have been specifically instructed to join without a camera,
              you may click the red "Continue Without Camera" button below.
            </div>
          ) : null}
          <div>
            {error.message}. Please make sure your audio and video devices are
            plugged in and turned on, then refresh.
          </div>
        </div>
      ) : (
        <div>
          Unknown error. Please try the following steps, in order:
          <ol className="pl-5 [&>li]:list-decimal">
            <li>Refresh the page.</li>
            <li>Restart your computer.</li>
            {userType === "Tutor" ? (
              <li>Reach out to your admin support channel in slack.</li>
            ) : userType === "Student" || userType === "Teacher" ? (
              <li>Click the green "Contact Support" button below.</li>
            ) : null}
          </ol>
        </div>
      )}
    </div>
  )
}

export default ErrorModal
